import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Actions from '../../../actions'
import $t from '../../../i18n'
import Alert from '../Alert'
import { Button } from 'antd'
import { hasChildren } from 'utils/familyUtils'
import { event, eventTypes } from '../../../consts/eventConsts'
import { BenefitTypeNames } from 'consts/coverageBenefitsConsts'

import './SSOAlert.css'

const SSOAlert = ({
  ssoLink,
  ssoLinkName,
  isSSONoteVisible,
  setIsSSONoteVisible,
}) => {
  const dispatch = useDispatch()
  const authenticatedLinks = useSelector(
    state => state.profile?.authenticatedLinks
  )

  const members = useSelector(state => state.account?.members)
  const navitusMinorsGuide = authenticatedLinks?.hmo_forms?.navitus_minors_guide

  const analyticsEvent = eventName => {
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.click,
        eventName: event.clickEvent.click,
        element: eventName,
      })
    )
  }

  const navigateToSSOLink = () => {
    analyticsEvent(`SSO link clicked - ${ssoLinkName}`)
    setIsSSONoteVisible(false)
    window.open(ssoLink, '_blank')
  }

  const alertTextByMemberRelation = () => {
    if (ssoLinkName === BenefitTypeNames.VISION) {
      return $t('pages.coverageBenefits.redirectVSPMsg')
    }

    return hasChildren(members) && ssoLinkName !== BenefitTypeNames.VISION
      ? $t('pages.prescriptions.minorsAlertSSo', {
          service: ssoLinkName,
        })
      : $t('pages.coverageBenefits.redirectSSOMsg', {
          service: ssoLinkName,
        })
  }

  const actionButtonsByMemberRelation = () => {
    const btnText =
      ssoLinkName === BenefitTypeNames.VISION
        ? $t('pages.coverageBenefits.goToVSP')
        : $t('common.continue')
    const actions = [
      <Button
        className="dialog-action"
        type="primary"
        key={ssoLinkName}
        onClick={navigateToSSOLink}
      >
        {btnText}
      </Button>,
    ]

    if (hasChildren(members) && ssoLinkName !== BenefitTypeNames.VISION) {
      actions.push(
        <Button
          className="action"
          type="secondary"
          key="minors-sso-guide"
          onClick={() => {
            window.open(navitusMinorsGuide, '_blank')
          }}
        >
          {$t('pages.prescriptions.downloadGuide')}
        </Button>
      )
    }

    return actions
  }

  return (
    <Alert
      title={$t('pages.coverageBenefits.redirectTitle')}
      className="redirect-note"
      shouldDisplay={isSSONoteVisible}
      closable={true}
      onCancel={() => setIsSSONoteVisible(false)}
      actions={actionButtonsByMemberRelation()}
    >
      {alertTextByMemberRelation()}
    </Alert>
  )
}

export default SSOAlert
